var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFootprints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 61,
    height: 68,
    viewBox: "0 0 61 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Objects",
    clipPath: "url(#clip0_83_487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.481 10.634C8.54072 10.634 6.29858 12.7807 4.23775 16.8565C2.8056 19.6893 2.593 23.0497 2.98951 26.2122C3.8595 33.1527 7.00422 36.1341 9.19353 44.0665C10.0231 47.0731 9.44201 49.6815 11.0268 52.3538C12.695 55.1667 15.8743 56.6127 19.8877 55.4684C25.8022 53.7819 25.5576 46.9219 23.9689 44.1824C22.3803 41.4428 20.2927 39.6284 18.9205 36.8035C17.5353 33.9514 17.3938 31.351 18.5618 28.4316C19.6986 25.5901 24.0374 20.8543 24.0374 17.4859C24.0374 13.2157 19.8186 10.6333 15.4804 10.6333",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.56472 10.3495C3.98276 11.6397 3.56015 12.9426 2.61974 13.2603C1.67997 13.578 0.57912 12.79 0.161084 11.4999C-0.256952 10.209 0.166301 8.90614 1.10607 8.58842C2.04583 8.2707 3.14734 9.05934 3.56472 10.3495Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7948 5.00159C13.0296 6.69876 12.217 8.21941 10.9805 8.39792C9.74396 8.57577 8.5518 7.34419 8.31768 5.64702C8.08355 3.94985 8.89549 2.42919 10.132 2.25135C11.3685 2.07284 12.5606 3.30442 12.7948 5.00159Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.62965 6.82331C7.95051 8.33398 7.31857 9.75672 6.21772 10.0005C5.11621 10.2443 3.96449 9.2172 3.64363 7.70587C3.32277 6.1952 3.95536 4.77246 5.05556 4.52934C6.15706 4.28489 7.30944 5.31198 7.62965 6.82331Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.8162 4.2296C18.9186 6.08663 17.9051 7.65525 16.5519 7.73384C15.198 7.81111 14.0189 6.36905 13.9165 4.51135C13.8148 2.65432 14.8282 1.08571 16.1815 1.00778C17.5347 0.929846 18.7144 2.37257 18.8162 4.2296Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.2434 5.90745C26.5143 8.55911 24.3583 10.2583 22.4266 9.70543C20.4949 9.15059 19.5212 6.55288 20.2496 3.90188C20.9788 1.25089 23.1355 -0.448278 25.0665 0.105234C26.9982 0.659412 27.9725 3.25712 27.2434 5.90811V5.90745Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M45.519 22.7719C52.4593 22.7719 54.7014 24.9187 56.7622 28.9944C58.1944 31.8273 58.407 35.1876 58.0105 38.3502C57.1405 45.2907 53.9958 48.2721 51.8065 56.2044C50.9769 59.2111 51.558 61.8195 49.9732 64.4918C48.305 67.3046 45.1257 68.7507 41.1123 67.6064C35.1979 65.9198 35.4424 59.0599 37.0311 56.3203C38.6197 53.5807 40.7073 51.7663 42.0795 48.9415C43.4647 46.0893 43.6062 43.489 42.4382 40.5695C41.3014 37.728 36.9626 32.9922 36.9626 29.6239C36.9626 25.3536 41.1814 22.7712 45.5196 22.7712",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M57.4353 22.4875C57.0172 23.7777 57.4398 25.0805 58.3803 25.3983C59.32 25.716 60.4209 24.928 60.8389 23.6378C61.257 22.3469 60.8337 21.0441 59.8939 20.7264C58.9542 20.4087 57.8527 21.1973 57.4353 22.4875Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M48.2052 17.1395C47.9705 18.8367 48.783 20.3574 50.0195 20.5359C51.256 20.7137 52.4482 19.4821 52.6823 17.785C52.9165 16.0878 52.1045 14.5671 50.868 14.3893C49.6315 14.2108 48.4394 15.4424 48.2052 17.1395Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M53.3704 18.9613C53.0495 20.4719 53.6814 21.8947 54.7823 22.1385C55.8838 22.3822 57.0355 21.3552 57.3564 19.8438C57.6772 18.3332 57.0446 16.9104 55.9444 16.6673C54.8429 16.4228 53.6906 17.4499 53.3704 18.9613Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M42.1838 16.3676C42.0814 18.2246 43.0949 19.7932 44.4481 19.8718C45.802 19.9491 46.9811 18.507 47.0835 16.6493C47.1852 14.7923 46.1718 13.2237 44.8185 13.1457C43.4653 13.0678 42.2855 14.5105 42.1838 16.3676Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M33.7566 18.0454C34.4857 20.6971 36.6417 22.3962 38.5734 21.8434C40.5051 21.2886 41.4788 18.6908 40.7504 16.0398C40.0212 13.3889 37.8645 11.6897 35.9335 12.2432C34.0018 12.7974 33.0275 15.3951 33.7566 18.0461V18.0454Z",
    fill: "#E6EDF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprints);
export default __webpack_public_path__ + "static/media/footprints.d4d4df643ba6704b8825c80e002d44d6.svg";
export { ForwardRef as ReactComponent };